<template>
  <div class="kszb-container">
    <div class="kszb-box">
    <div class="kszb-left">
      <div class="kszb-section-title">{{$t('all.jichushezhi')}}</div>
      <!-- 基础设置表单 -->
      <div class="kszb-form-row">
        <div class="kszb-form-item">
          <span class="kszb-form-item-label">{{$t('all.zhibojianbiaoti')}}</span>
          <input class="kszb-form-item-input" v-model="form.title" :placeholder="$t('all.geinidezhibojianqugemingziba')" />
		  <img class="kszb-form-item-icon" src="../../../assets/image/bianji_28@2x.png" alt="" />
        </div>
        <div class="kszb-form-item" @click="showBgModal = true">
          <span class="kszb-form-item-label">{{$t('all.zhibojianbeijing')}}</span>
          <span class="kszb-form-item-value kszb-text-green" v-if="form.bgUrl">{{$t('all.yishangchuan')}}</span>
          <span class="kszb-form-item-value" v-else>{{$t('all.qingshangchuan')}}</span>
          <img class="kszb-form-item-icon" src="../../../assets/image/shangchuan_28@2x.png" alt="" />
        </div>
        <div class="kszb-form-item" @click="handleUploadCover">
          <span class="kszb-form-item-label">{{$t('all.zhibojianfengmian')}}</span>
          <span class="kszb-form-item-value kszb-text-green" v-if="form.backgroundUrl">{{$t('all.yishangchuan')}}</span>
          <span class="kszb-form-item-value" v-else>{{$t('all.qingshangchuan')}}</span>
          <img class="kszb-form-item-icon" src="../../../assets/image/shangchuan_28@2x.png" alt="" />
          <input type="file" ref="coverInput" style="display:none" accept="image/*" @change="handleCoverChange" />
        </div>
      </div>
      <div class="kszb-form-row">
        <div class="kszb-form-item kszb-form-item-select" @click="showCategoryDropdown = !showCategoryDropdown">
          <span class="kszb-form-item-label">{{$t('all.zhibojianbiaoqian')}}</span>
          <span class="kszb-form-item-value">{{form.categoryName || $t('all.qingxuanze')}}</span>
          <img class="kszb-form-item-icon" src="../../../assets/image/biaoqian_28@2x.png" alt="" />
          <div class="kszb-dropdown" v-if="showCategoryDropdown" @click.stop>
            <div 
              class="kszb-dropdown-item" 
              v-for="item in categoryList" 
              :key="item.id" 
              :class="{ 'kszb-dropdown-item-active': form.categoryId === item.id }"
              @click="handleSelectCategory(item)"
            >{{item.categoryName}}</div>
          </div>
        </div>
        <div class="kszb-form-item">
          <span class="kszb-form-item-label">{{$t('all.zhibojinyao')}}</span>
          <input class="kszb-form-item-input" v-model="form.liveKey" :placeholder="$t('all.qingshurukaibomiyao')" />
          <img class="kszb-form-item-icon" src="../../../assets/image/jinyao_28@2x.png" alt="" />
        </div>
      </div>
      <!-- 画质选择 -->
      <div class="kszb-quality-row">
        <div 
          :class="qualityIndex === index ? 'kszb-quality-active' : 'kszb-quality'" 
          v-for="(item, index) in qualityList" 
          :key="index"
          @click="qualityIndex = index"
        >{{item.label}}</div>
      </div>
      <!-- 直播商品 -->
      <!-- <div class="kszb-goods-item" @click="handleGoGoods">
        <span class="kszb-goods-label">{{$t('all.zhiboshangpin')}}</span>
        <span class="kszb-goods-desc">{{$t('all.laiziyunimall')}}</span>
        <span class="kszb-goods-count">{{form.goodsCount}}{{$t('all.jian')}}</span>
		<img class="kszb-form-item-icon" src="../../../assets/image/shangpin_28@2x.png" alt="" />
      </div> -->
      <!-- 开始直播按钮 -->
      <div class="kszb-btn" @click="handleStart">{{$t('all.kaishizhibo')}}</div>
    </div>
    <!-- <div class="kszb-right"> -->
  </div>
  
  <!-- 背景图选择弹框 -->
  <div class="kszb-bg-overlay" v-if="showBgModal" @click="showBgModal = false"></div>
  <div class="kszb-bg-modal" v-if="showBgModal" @click.stop>
    <div class="kszb-bg-modal-header">
      <span class="kszb-bg-modal-title">{{$t('all.xuanzebackground')}}</span>
      <img class="kszb-bg-modal-close" @click="showBgModal = false" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" />
    </div>
    <div class="kszb-bg-modal-body">
      <!-- 已选择预览 -->
      <div class="kszb-bg-preview" v-if="selectedBgUrl">
        <span class="kszb-bg-preview-label">{{$t('all.yixuanze')}}</span>
        <img :src="selectedBgUrl" alt="" class="kszb-bg-preview-img" />
      </div>
      <div class="kszb-bg-grid">
        <!-- 上传背景 -->
        <div class="kszb-bg-item kszb-bg-item-upload" @click="handleUploadBg">
          <div class="kszb-bg-upload-icon">+</div>
          <span class="kszb-bg-upload-text">{{$t('all.shangchuanbeijing')}}</span>
          <input type="file" ref="bgInput" style="display:none" accept="image/*" @change="handleBgChange" />
        </div>
        <!-- 接口返回的背景列表 -->
        <div 
          class="kszb-bg-item" 
          v-for="item in bgList" 
          :key="item.id"
          :class="{ 'kszb-bg-item-active': selectedBgUrl === item.imgUrl }"
          @click="handleSelectBg(item)"
        >
          <img :src="item.imgUrl" alt="" class="kszb-bg-img" />
        </div>
      </div>
    </div>
    <!-- 上传进度 -->
    <div class="kszb-bg-progress" v-if="uploadProgress > 0 && uploadProgress < 100">
      <div class="kszb-bg-progress-bar">
        <div class="kszb-bg-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
      </div>
      <span class="kszb-bg-progress-text">{{uploadProgress}}%</span>
    </div>
    <!-- 确认按钮 -->
    <div class="kszb-bg-modal-footer">
      <div class="kszb-bg-modal-cancel" @click="showBgModal = false">{{$t('all.quxiao')}}</div>
      <div class="kszb-bg-modal-confirm" @click="handleConfirmBg">{{$t('all.queren')}}</div>
    </div>
  </div>
  </div>
</template>

<script>
import { startLive, getLiveCategoryList } from "@/api/zhibo";
import { getLiveBgList } from "@/api/zhubo";
import { client as createCosClient } from '../../../common/js/txycos';
export default {
  data() {
    return {
      form: {
        title: '',
        backgroundUrl: '',
        categoryId: '',
        liveKey: '',
        goodsCount: 4,
		categoryName:'',
		bgUrl:''
      },
      qualityIndex: 1,
      qualityList: [],
      flowList: [],
      categoryList: [],
      bgList: [],
      cosClient: null,
      showCategoryDropdown: false,
      showBgModal: false,
      uploadProgress: 0,
      selectedBgUrl: ''
    };
  },
  computed: {
    selectedCategoryName() {
      const item = this.categoryList.find(c => c.id === this.form.categoryId);
      return item ? item.categoryName : '';
    }
  },
  mounted() {
    this.cosClient = createCosClient();
    this.qualityList = [
	  {
		value:1,
		label:this.$t('all.biaoqinghuazhi')
	  },
	  {
		value:0,
		label:this.$t('all.gaoqinghuazhi')
	  },
	  {
		value:2,
		label:this.$t('all.chaoqinghuazhi')
	  }
    ];
    this.getCategoryList();
  },
  watch: {
    showBgModal(val) {
      if (val) {
        this.getBgList();
        this.selectedBgUrl = this.form.bgUrl || '';
      }
    }
  },
  methods: {
    async getCategoryList() {
      try {
        const res = await getLiveCategoryList();
        this.categoryList = res.data || res.rows || [];
      } catch (error) {
        console.error('获取直播分类失败:', error);
      }
    },
    async getBgList() {
      try {
        const res = await getLiveBgList();
        this.bgList = res.data || res.rows || [];
      } catch (error) {
        console.error('获取背景列表失败:', error);
      }
    },
    handleUploadBg() {
      this.$refs.bgInput.click();
    },
    handleUploadCover() {
      this.$refs.coverInput.click();
    },
    handleCoverChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.uploadCover(file);
    },
    async uploadCover(file) {
      try {
        this.uploadProgress = 0;
        const fileExt = file.name.split('.').pop() || 'png';
        const fileName = `webStorage/web_${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;
        await new Promise((resolve, reject) => {
          this.cosClient.putObject({
            Bucket: this.cosClient.options.bucket,
            Region: this.cosClient.options.region,
            Key: fileName,
            Body: file,
            ContentType: file.type || 'image/png',
            onProgress: (progressData) => {
              this.uploadProgress = Math.round((progressData.loaded / progressData.total) * 100);
            }
          }, (err, result) => {
            if (err) reject(err);
            else resolve(result);
          });
        });
        this.uploadProgress = 100;
        this.form.backgroundUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
        this.$message.success(this.$t('all.yishangchuan'));
        setTimeout(() => {
          this.uploadProgress = 0;
        }, 500);
      } catch (error) {
        console.error('封面上传失败:', error);
        this.uploadProgress = 0;
        this.$message.error(this.$t('all.shangchuanshibai'));
      }
    },
    handleSelectBg(item) {
      this.selectedBgUrl = item.imgUrl;
    },
    handleConfirmBg() {
      if (this.selectedBgUrl) {
        this.form.bgUrl = this.selectedBgUrl;
        this.showBgModal = false;
      } else {
        this.$message.warning(this.$t('all.qingxuanzebeijing'));
      }
    },
    handleSelectCategory(item) {
	  console.log(item)
      this.form.categoryId = item.id;
	  this.form.categoryName = item.categoryName
      this.showCategoryDropdown = false;
    },
    handleGoGoods() {
      this.$router.push('/zhiboshangpin');
    },
    handleBgChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.uploadImage(file);
    },
    async uploadImage(file) {
      try {
        this.uploadProgress = 0;
        const fileExt = file.name.split('.').pop() || 'png';
        const fileName = `webStorage/web_${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;
        await new Promise((resolve, reject) => {
          this.cosClient.putObject({
            Bucket: this.cosClient.options.bucket,
            Region: this.cosClient.options.region,
            Key: fileName,
            Body: file,
            ContentType: file.type || 'image/png',
            onProgress: (progressData) => {
              this.uploadProgress = Math.round((progressData.loaded / progressData.total) * 100);
            }
          }, (err, result) => {
            if (err) reject(err);
            else resolve(result);
          });
        });
        this.uploadProgress = 100;
        const bgUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
        this.selectedBgUrl = bgUrl;
        this.$message.success(this.$t('all.yishangchuan'));
        setTimeout(() => {
          this.uploadProgress = 0;
        }, 500);
      } catch (error) {
        console.error('上传失败:', error);
        this.uploadProgress = 0;
        this.$message.error(this.$t('all.shangchuanshibai'));
      }
    },
    async checkMediaPermission() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.warning(this.$t('all.browserbu支持'));
        return false;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.error('媒体权限获取失败:', error.name, error.message);
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          this.$message.warning('摄像头和麦克风权限被拒绝，请在浏览器地址栏左侧点击锁/信息图标，允许摄像头和麦克风权限后刷新页面');
        } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
          this.$message.warning('未检测到摄像头或麦克风设备，请检查设备是否已连接');
        } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
          this.$message.warning('设备被其他应用占用，请关闭其他使用摄像头/麦克风的程序后重试');
        } else {
          this.$message.warning('无法获取设备权限，请检查浏览器设置');
        }
        return false;
      }
    },
    async handleStart() {
      if (!this.form.title) {
        this.$message.warning(this.$t('all.geinidezhibojianqugemingziba'));
        return;
      }
      if (!this.form.liveKey) {
        this.$message.warning(this.$t('all.qingshurukaibomiyao'));
        return;
      }
      try {
        const hasPermission = await this.checkMediaPermission();
        if (!hasPermission) {
          return;
        }
        const params = {
          name: this.form.title,
          backgroundUrl: this.form.backgroundUrl,
		  bgUrl: this.form.bgUrl,
          categoryId: this.form.categoryId,
          startKey: this.form.liveKey,
          livePictureQuality: this.qualityList[this.qualityIndex].value
        };
        const res = await startLive(params);
        this.$message.success(res.msg);
        console.log('开始直播返回数据:', res);
        const liveId = res.data
        if (liveId) {
          this.$router.push({ 
            path: '/zhibozhong', 
            query: { 
              liveId: liveId
            } 
          });
        } else {
          console.error('开始直播成功但未返回liveId:', res);
        }
      } catch (error) {
        console.error('开始直播失败:', error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./kaishizhibo.css";
</style>



// WEBPACK FOOTER //
// kaishizhibo.vue?51af9f12